"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _r10CommonComponents = require("r10-common-components");
var _useTranslation = _interopRequireDefault(require("../../hooks/useTranslation"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _Actions = require("../../actions/Actions");
var _selector = require("../../selectors/selector");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var CancelConfirmation = function CancelConfirmation(_ref) {
  var expirationDate = _ref.expirationDate,
    id = _ref.id,
    name = _ref.name;
  var t = (0, _useTranslation.default)();
  var dispatch = (0, _reactRedux.useDispatch)();
  var dateFormat = (0, _reactRedux.useSelector)(_selector.dateFormatSelector);
  var cancelAddonConfirm = function cancelAddonConfirm() {
    dispatch({
      type: _Actions.HIDE_POPUP
    });
    dispatch({
      type: _Actions.RESET_CANCEL_ADDON
    });
    dispatch((0, _Actions.updateAddonsAfterCancel)({
      id: id
    }));
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Icon, {
    name: "tick-outline",
    size: 4,
    appearance: "secondary",
    group: "hifiLight"
  })), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: 7,
      top: 8
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    size: 2,
    justify: "center",
    weight: 3,
    text: t('addonCancelled'),
    dataAttributes: {
      'data-testid': 'addonCancelled'
    }
  }))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: 8
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    size: 1,
    justify: "center",
    weight: 1,
    dataAttributes: {
      'data-testid': 'confirmMsg'
    }
  }, name, " ", t('confirmationMsg1')), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Span, {
    weight: 1
  }, " ", t('confirmationMsg2'), " "), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Span, {
    weight: 4
  }, _r10CommonComponents.utils.formatDate(expirationDate, dateFormat))))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: "center",
    disableFlex: true
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: 8,
      left: 8,
      right: 8
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
    width: "full",
    text: t('backAddons'),
    onClick: cancelAddonConfirm,
    dataAttributes: {
      'data-testid': 'backAddons'
    }
  })))));
};
CancelConfirmation.propTypes = {
  expirationDate: _propTypes.default.string.isRequired,
  id: _propTypes.default.string.isRequired,
  name: _propTypes.default.string.isRequired
};
var _default = CancelConfirmation;
exports.default = _default;